exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /Users/balazskaxd/dev/rkk/rkk-webapp/~/core-js/library/modules/_wks-ext.js
// module id = 182
// module chunks = 20